import { useLanguage, t } from "../../../i18n";
import React, { useMemo, useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ProfileForm, { profileInitialValues } from "../../../components/profile/ProfileForm/ProfileForm";
import ROUTES from "../../../config/routes";
import "./CompleteProfile.css";
import Logo from "../../../components/common/Logo/Logo";
import completeUserProfile from "../../../features/profile/services/completeUserProfile";
import { useAuth } from "../../../features/auth/context/AuthContext";
export default function CompleteProfile() {
  useLanguage();
  const navigate = useNavigate();
  const {
    user,
    setUser
  } = useAuth();
  useEffect(() => {
    if (user?.profile_status === "complete") {
      navigate(ROUTES.HOME, {
        replace: true
      });
    }
  }, [user, navigate]);
  const prefilledInitialValues = useMemo(() => {
    return {
      ...profileInitialValues,
      name: user?.full_name || user?.name || "",
      email: user?.email || "",
      contactNumber: user?.mobile || ""
    };
  }, [user]);
  const handleSubmit = async (values, formikHelpers) => {
    const {
      setSubmitting
    } = formikHelpers;
    try {
      setSubmitting(true);
      const response = await completeUserProfile(values);
      if (response?.status) {
        const latestUser = response?.data;
        if (latestUser) {
          setUser(prev => ({
            ...(prev || {}),
            ...latestUser,
            name: latestUser?.full_name || prev?.name || "",
            full_name: latestUser?.full_name || prev?.full_name || "",
            email: latestUser?.email || prev?.email || "",
            mobile: latestUser?.mobile || prev?.mobile || "",
            profile_status: latestUser?.profile_status || prev?.profile_status || "",
            nafath_status: latestUser?.nafath_status || prev?.nafath_status || ""
          }));
        }
        toast.success(t(response?.message || "Profile completed successfully."));
        navigate(ROUTES.HOME, {
          replace: true
        });
        return;
      }
      toast.error(t(response?.message || "Failed to complete profile."));
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || "Something went wrong while completing the profile.";
      toast.error(t(errorMessage));
      console.error("Complete profile error:", error);
    } finally {
      setSubmitting(false);
    }
  };
  return <div className="bb-complete-profile-page">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={9}>
            <div className="bb-complete-profile-logo">
              <Logo />
            </div>

            <div className="bb-complete-profile-page__header">
              <h1 className="bb-complete-profile-page__title">{t("Complete Your Profile")}

              </h1>
              <p className="bb-complete-profile-page__subtitle">{t("Complete your profile to continue using BaytBuddy and unlock the roommate discovery experience.")}


              </p>
            </div>

            <Card className="bb-complete-profile-card">
              <Card.Body>
                <ProfileForm initialValues={prefilledInitialValues} submitLabel={t("Save & Continue")} onSubmit={handleSubmit} onCancel={() => navigate(ROUTES.ROOT)} lockIdentityFields />

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>;
}
